import React from 'react';
import PropTypes from 'prop-types';
import { Container, Text } from '@chakra-ui/react';
import SimpleSlider from '@repo/ui-components/dept/molecules/SimpleSlider';
import WhatsNewItem from './WhatsNewItem';

function WhatsNew({ block }) {
  if (!block) return null;

  const { title, items } = block;

  return (
    <Container>
      <Text textStyle="h2" color="typography.light" py="26px">
        {title}
      </Text>
      {block.copy?.length && (
        <Text textStyle="body" color="typography.base">
          {block.copy}
        </Text>
      )}
      <SimpleSlider mt={4} items={items} sliderItem={WhatsNewItem} />
    </Container>
  );
}

WhatsNew.propTypes = {
  block: PropTypes.shape({
    items: PropTypes.arrayOf(PropTypes.shape({})),
  }),
}.isRequired;

export default WhatsNew;
